function buildStripePaymentElementBillingDetails(order) {
    if (!order) {
        return null;
    }

    var billingDetails = {};
    var displayName = ((order.Firstname || '') + ' ' + (order.Lastname || '')).trim();

    if (displayName) {
        billingDetails.name = displayName;
    }
    if (order.Email) {
        billingDetails.email = String(order.Email).trim();
    }
    if (order.Phone) {
        billingDetails.phone = String(order.Phone).trim();
    }

    var addr = {};
    if (order.Street) {
        addr.line1 = String(order.Street).trim();
    }
    if (order.Address2) {
        addr.line2 = String(order.Address2).trim();
    }
    if (order.Postalcode) {
        addr.postal_code = String(order.Postalcode).trim();
    }
    if (order.City) {
        addr.city = String(order.City).trim();
    }
    if (order.State) {
        addr.state = String(order.State).trim();
    }

    var country = order.Country ? String(order.Country).trim() : '';
    if (country.length === 2) {
        addr.country = country.toUpperCase();
    }

    if (Object.keys(addr).length > 0) {
        billingDetails.address = addr;
    }

    return Object.keys(billingDetails).length > 0 ? billingDetails : null;
}

function syncStripePaymentElementBillingDetails(order) {
    if (typeof window === 'undefined') {
        return null;
    }

    var billingDetails = buildStripePaymentElementBillingDetails(order);
    window.stripePaymentElementBillingDetails = billingDetails;

    if (billingDetails && window.stripePaymentElement && typeof window.stripePaymentElement.update === 'function') {
        window.stripePaymentElement.update({ defaultValues: { billingDetails: billingDetails } });
    }

    return billingDetails;
}
